import { render, staticRenderFns } from "./seleccionados_aprob.vue?vue&type=template&id=ea3f4048"
import script from "./seleccionados_aprob.vue?vue&type=script&lang=js"
export * from "./seleccionados_aprob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports